import { render, staticRenderFns } from "./DocumentsList.vue?vue&type=template&id=9b5a6b7c&"
import script from "./DocumentsList.vue?vue&type=script&lang=js&"
export * from "./DocumentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports